import { render, staticRenderFns } from "./Laboratories.vue?vue&type=template&id=579a6dd9&scoped=true&"
import script from "./Laboratories.vue?vue&type=script&lang=js&"
export * from "./Laboratories.vue?vue&type=script&lang=js&"
import style0 from "./Laboratories.vue?vue&type=style&index=0&id=579a6dd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579a6dd9",
  null
  
)

export default component.exports